<template>
	<v-card class="filters">
		<v-checkbox
			v-model="showFinished"
			label="Mostrar carreras terminadas"
			@change="filterChanged"
		></v-checkbox>
		<v-checkbox
			v-model="showOnlyFree"
			label="Mostrar solo carreras gratis"
			@change="filterChanged"
			color="accent"
		></v-checkbox>
		<v-range-slider
			v-model="range"
			thumb-label
			max="200"
			@change="filterChanged"
		>
			<template #prepend>Distancia total</template>
			<template #append>km</template>
		</v-range-slider>
	</v-card>
</template>

<script>
	export default {
		data: () => ({
			showFinished: false,
			showOnlyFree: false,
			range: [0, 200],
		}),
		methods: {
			filterChanged() {
				this.$emit("filterChanged", {
					finished: this.showFinished,
					free: this.showOnlyFree,
					range: this.range,
				});
			},
		},
	};
</script>

<style lang="scss" scoped>
	.filters {
		margin-top: 2em;
		padding: 2em;
	}
</style>